import gql from 'graphql-tag'

export const GET_ADVISORY_DATA = gql`
query getAdvisoryData{
  getAdvisoryData
}
`
